export enum FeatureFlagCodes {
	FUNDING_SCREEN = "Q1_2026_FUNDING",
	Q1_2026_WPAY_CPNOW_INTEGRATION = "Q1_2026_WPAY_CPNOW_INTEGRATION",
	FE_KPI_CARDS = "FE_KPI_CARDS",
	FUNDING_SCREEN_TPP = "FUNDING_SCREEN_TPP",
	EBURY_MIGRATION = "EBURY_MIGRATION",
	TPP_EBURY_MIGRATION = "TPP_EBURY_MIGRATION",
	Q1_2026_WPAY_CPNOW_INTEGRATION_PG = "Q1_2026_WPAY_CPNOW_INTEGRATION_PG",
	CALENDAR_ERROR = "CALENDAR_ERROR",
	Q3_TIMEZONE_FE = "Q3_TIMEZONE_FE"
}
